import { Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormControl } from '@angular/forms';
import { filter, pairwise } from 'rxjs/operators';
import { APPLICATION_TYPES } from 'src/app/model/constants/application-types';
import { LEGITIMATION_STATUS } from 'src/app/model/constants/legitimation-status';
import { ITeacherLegitimation } from 'src/app/model/service/iteacher-legitimation';
import { IUser } from 'src/app/model/service/iuser';
import { APPLICATION_NAMES } from 'src/app/service/ansokan-form-builder/application-names';
import { AnsokanFormGroupService } from 'src/app/service/ansokan-form-group/ansokan-form-group.service';
import { AuthService } from 'src/app/service/auth/auth.service';
import { LegitimationService } from 'src/app/service/legitimation/legitimation.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-start',
    styleUrls: ['./start.component.scss'],
    templateUrl: './start.component.html',
    standalone: false
})
export class StartComponent implements OnInit {

  public revoked: boolean;
  public user: IUser;
  public ssn: UntypedFormControl;
  private type: AbstractControl;

  public get allowSsnChange(): boolean {
    return environment.allowSsnChange;
  }

  constructor(
    private groupService: AnsokanFormGroupService,
    private legService: LegitimationService,
    private authService: AuthService,
  ) { }

  public ngOnInit() {
    // Get controls.
    this.type = this.groupService.get(APPLICATION_NAMES.APPLICATION_TYPE);
    this.ssn = this.groupService.get(APPLICATION_NAMES.APPLICANT_SSN) as UntypedFormControl;
    // Create ssn value subscription.
    this.ssn.valueChanges
      .pipe(pairwise())
      .pipe(filter(([oldVal, newVal]) => oldVal !== newVal))
      .subscribe(([oldVal, newVal]) => this.setType(newVal));
    this.ssn.updateValueAndValidity();
    // Set user data.
    this.user = this.authService.getUser();
    if (this.user) {
      this.ssn.setValue(this.user.ssn);
    }
    // Set arrival date.
    this.groupService.get(APPLICATION_NAMES.ARRIVAL_DATE).setValue(new Date().toLocaleDateString('sv-SE'));
  }

  private setType(value: string): void {
    this.type.setValue(null);
    if (this.ssn.valid) {
      // Get Legitimation.
      this.legService
        .getLegitimation(value)
        .subscribe((result: ITeacherLegitimation) => {
          this.revoked = result.status === LEGITIMATION_STATUS.REVOKED;
          const type = this.toType(result);
          this.type.setValue(type);
        });
    }
  }

  private toType(leg: ITeacherLegitimation): string {
    switch (leg.status) {
      case LEGITIMATION_STATUS.NONE:
        return APPLICATION_TYPES.NEW_SWEDISH;
      case LEGITIMATION_STATUS.ACTIVE:
        return APPLICATION_TYPES.SUPPLEMENT_SWEDISH;
      case LEGITIMATION_STATUS.REVOKED:
        return null;
    }
  }
}
